import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { buildQuery } from "../../../utils/buildQuery";

export const CustomerPermissionsApi = createApi({
	reducerPath: "CustomerPermissions",
	baseQuery: fetchBaseQuery({
		baseUrl: process.env.REACT_APP_BACKEND_URL,
		prepareHeaders: (headers) => {
			const token = localStorage.getItem("token");
			if (token) {
				headers.set("Authorization", `Bearer ${token}`);
			}
			return headers;
		},
		credentials: "include",
	}),
	endpoints: (builder) => ({
		addCustomerPermission: builder.mutation({
			query: (val) => ({
				url: `customer/permissions`,
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: val,
			}),
		}),
		deleteCustomerPermission: builder.mutation({
			query: (val) => ({
				url: `customer/permissions`,
				method: "DELETE",
				headers: { "Content-Type": "application/json" },
				body: val,
			}),
		}),
		getDeviceAssignmentReport: builder.query({
		query: (params) => {
			const query = buildQuery(params);
			return `/reports/devices/assignment-history${query}`;
		},
		}),
		getDeviceAssignmentHistory: builder.query({
			query: (params) => {
				const query = buildQuery(params);
				return `/reports/devices/assignment-history/${params.deviceId}${query}`;
			},
		}),
	}),
});

export const {
	useAddCustomerPermissionMutation,
	useDeleteCustomerPermissionMutation,
	useLazyGetDeviceAssignmentReportQuery,
	useGetDeviceAssignmentHistoryQuery
} = CustomerPermissionsApi;
